<template>

    <section class="admin-section" aria-labelledby="admin-actions-heading">
      <PricesManagerSettingsList/>
    </section>

  <section class="admin-section" aria-labelledby="admin-actions-heading">
    <div class="admin-header">
      <div class="admin-title-row">
        <h5 id="admin-actions-heading" class="admin-title">Administracja</h5>
        <span class="admin-badge">Sekcja tylko dla administratora</span>
      </div>
      <p class="admin-description">
        Narzędzia administracyjne związane z zarządzaniem centralnymi cenami.
      </p>
    </div>
    <div class="admin-actions">
      <button
          class="admin-action admin-action--primary"
          type="button"
          @click="getLastArchiveFilePath"
      >
        <span class="admin-action__icon" aria-hidden="true">  <i class="bx bx-archive-in align-middle font-size-16"/></span>
        <span class="admin-action__content">
              <span class="admin-action__title">Odzyskaj ceny z ostatniego archiwum</span>
              <span class="admin-action__subtitle">Uruchom procedurę</span>

            </span>
      </button>
      <!-- Przyszłe akcje administracyjne można dodawać jako kolejne przyciski w tej siatce -->
    </div>
  </section>

</template>

<script>
import PricesManagerSettingsList from "../PricesManager/PricesManagerSettingsList.vue";
import {apiRequestsHelper} from "@/state/pinia/apiRequestHelper";
import Swal from "sweetalert2";
import {settingsHelperFunctions} from "@/helpers/settingsHelper";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";
import {usePricesManagerModule} from "@/state/pinia/pricesManagerModule";


export default {
  name: "PricesManagerSettingsStage",
  components: {PricesManagerSettingsList},
  data() {
    return {}
  },
  computed: {
    pricesModule() {
      return usePricesManagerModule();
    },
    simplepharmAuth() {
      return useSimplepharmAuthModule();
    },
    commonModule() {
      return useCommonAppModule();
    },
    lazyloaderModule() {
      return useLazyLoaderModule();
    },
  },
  methods: {


    getLastArchiveFilePath() {
      this.pricesModule.httpGetLastArchiveFileName().then((response) => {
        apiRequestsHelper.handleResponseWithDialogs(response, false);
        Swal.fire({
          title: "Czy na pewno?",
          text: "Czy na pewno chcesz odzyskać ceny na podstawie archiwum: " + response.data.payload + "?. Operacja jest nieodwracalna!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          cancelButtonText: "Nie",
          confirmButtonText: "Tak",
          dangerMode: true,
        }).then((result) => {
              if (result.value) {
                this.pricesModule.httpRestorePricesFromLastArchiveProcedure();
              } else {

                // Do nothing...
              }
            }
        )
      })
          .catch((error) => {
            apiRequestsHelper.catchResponseError(error,"httpGetLastArchiveFileName");
          });
    },
  },

  mounted() {
    this.commonModule.setHorizontalNavbarTitle(`<i class="bx bx-home-circle me-1"></i> Ustawienia Centralnych Cen`)
  },
  created() {
    this.simplepharmAuth.refreshToken().then(() => {
      this.commonModule.httpGetLicensedFeatures();
      this.commonModule.httpGetWorkingProfile();
    });
  }
}
</script>

<style scoped>
</style>
